import { ConfirmationService, Message } from 'primeng/primeng';
import { AgentService } from './../../../services/agent.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chargement-dg-revendeur',
  templateUrl: './chargement-dg-revendeur.component.html',
  styleUrls: ['./chargement-dg-revendeur.component.css']
})
export class ChargementDgRevendeurComponent implements OnInit {
  dateValue: Date;
  uploadedFile: File;
  displaychargement = false;
  msgs: Message[] = [];
  colorFieldset = 'primary';
  colorPanel = 'primary';
  produit: any;
  loadResponse: any = new Object();
  listProduit: any[] = [
    {
      value: '',
      label: '--Selectionner--'
    },
    {
      value: 'NAFAMA',
      label: 'NAFAMA'
    },
    {
      value: 'ORANGE_MONEY',
      label: 'ORANGE_MONEY'
    },
    {
      value: 'DUAL_WALLET',
      label: 'DUAL_WALLET'
    }
  ];
  constructor(
    private agentService: AgentService,
    private confirmationService: ConfirmationService) {
  }

  ngOnInit() {
  }
  async charger() {
    this.displaychargement = true;
    if (!this.uploadedFile) {
      this.msgs = []; this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Merci de choisir un fichier' });
    } else if (!this.dateValue) {
      this.msgs = []; this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Merci de choisir une période' });
    } else if (!this.produit) {
      this.msgs = []; this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Merci de choisir un produit' });
    } else {
      const formData = new FormData();
      formData.append('file', this.uploadedFile);
      // formData.append('periode', this.dateValue.toLocaleDateString());
      // formData.append('produit', this.produit);
      console.log('formData: ', formData);
      try {
        this.loadResponse = (await this.load(formData) as any);
        this.msgs = []; this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Vérification effectuée avec succès' });
      } catch (error) {
        this.msgs = []; this.msgs.push({ severity: 'warring', summary: 'Confirmation', detail: 'Vérification échouée' });
      } finally {
        this.displaychargement = false;
      }

      console.log('loadResponse: ', this.loadResponse);
    }
  }

  async load(formData: any) {
    return await this.agentService.chargerDgRevendeur(formData).toPromise();
  }

  refaire() {
    window.location.reload();
  }


  exportCharges() {
  }

  async doSend() {
    this.displaychargement = true;
    try {
      await this.send();
      this.msgs = []; this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Chargement effectuée avec succès' });
    } catch (error) {
      this.msgs = []; this.msgs.push({ severity: 'warring', summary: 'Confirmation', detail: 'Chargement échoué' });
    } finally {
      this.displaychargement = false;
    }
  }

  async send() {
    return await this.agentService.sendDgClient().toPromise();
  }

  detectFiles0(event) {
    this.uploadedFile = event.target.files[0];
    console.log('files: ', this.uploadedFile);
  }

  exportClients() {
  }


  exportErreurs() {
  }

  exportSendResponse() {
  }

}

